var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pill',_vm._b({attrs:{"href":_vm.shareUrl,"target":"_blank"}},'pill',_vm.$attrs,false),[_vm._v("Share this Story")])
}
var staticRenderFns = []

export { render, staticRenderFns }